// start:ng42.barrel
export * from './rate-rule.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/rate-rule/index.ts